<template>
  <tela-component title="Selecionar tipo do pedido" rota="/">
    <v-list-item
      two-line
      v-for="(tp, i) in tiposPedidoEmissao"
      :key="i"
      @click="irRota(tp)"
      class="mt-3 white"
    >
      <v-list-item-content>
        <v-list-item-title class="title">{{ tp.opcao }}</v-list-item-title>
      </v-list-item-content>
      <v-list-item-action>
        <v-icon>mdi-arrow-right</v-icon>
      </v-list-item-action>
    </v-list-item>
  </tela-component>
</template>

<script>
import TelaComponent from "@/components/tela/TelaComponent.vue";
import { mapState } from "vuex";

export default {
  components: { TelaComponent },
  computed: {
    ...mapState("usuario", ["usuarioLogado"]),
    ...mapState("pedidos", ["tiposPedidoEmissao"]),
  },
  methods: {
    irRota(value) {      
      if (this.$route.params.tipo == "pedidos") {
        this.$router.push({ path: value.rotaPedidos });
      } else {
        sessionStorage.removeItem("pedido_item");
        this.$store.commit("pedidos/resetState");
        this.$router.push({ path: value.rota });
      }
    },
  },
  created() {    
    if (!this.usuarioLogado.vendedor_coasul) {
      if (this.$route.params.tipo == "emissao") {
        this.$router.push({ path: "/novo-pedido" });
      } else {
        this.$router.push({ path: "/central-pedidos" });
      }
    }
  },
};
</script>

<style>
</style>